import React from 'react';
import Routing from './Routing';
import './App.css'
import { LoaderProvider, SourceProvider, UserDetailProvider } from "./Context/userContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  return (
    <div>
      <LoaderProvider>
        <UserDetailProvider>
          <SourceProvider>
            <Routing />
          </SourceProvider>
          <ToastContainer />
        </UserDetailProvider>
      </LoaderProvider>

    </div>
  )
}
export default App;

